"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (_a) {
    var truncate = _a.truncate;
    return truncate &&
        "\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n";
});
